import * as React from "react";
import * as ReactDOM from "react-dom";
import Ajax from "../../Ajax";
import TypesList from "./TypesList";
import WelcomePage from "./WelcomePage";

interface IFormProps {
}
interface MyStates {
  ajaxLoaded: boolean,
  types: object,
  welcomepage: object,
  gallery: object
}
export default class ReservatioSettings extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: false,
      types: {},
      welcomepage: {},
      gallery: {}
    }
    this.getDatas()
  }
  private getDatas(){

    var ajax = new Ajax(window.location.origin+ '/reservatio/beallitasok/getDatas');
    ajax.doPost({}).then((response) => {
      this.setState({
        types: response.types,
        welcomepage: response.welcomepage.data,
        gallery: response.welcomepage.gallery,
        ajaxLoaded: true,
      })
    })
  }

  public render() {
    if(this.state.ajaxLoaded === true){
      return (
      <>
        <div className="row">
          <div className="col-md-6">
            <WelcomePage data={this.state.welcomepage} gallery={this.state.gallery}/>
          </div>
          <div className="col-md-6">
            <TypesList types={this.state.types} />
          </div>
        </div>
      </>
      );
    }else{
      return (<>Betöltés..</>)
    }
  }
}

export class InitReservatioSettings {
  constructor() {
      var div: HTMLDivElement = document.getElementById('reservatio_settings_app') as HTMLDivElement;
      if (div !== null) {
          var data:any = div.dataset;
          ReactDOM.render(<ReservatioSettings />, div);
      }
  }
}